import React, { FC, useEffect, useState } from 'react';
import Link from 'evcharging/components/Link';
import { detectMobileOS, MobileOS } from 'evcharging/utils/device';
import { APP_STORE_LINK, GOOGLE_PLAY_LINK } from 'evcharging/app';
import InlineGap from 'evcharging/components/InlineGap';
import Image from 'next/image';
import { appStore, googlePlay } from 'evcharging/assets/home';

interface SoftwareButtonProps {
  showDesktop?: boolean;
}

const SoftwareButton: FC<SoftwareButtonProps> = (props) => {
  const { showDesktop = false } = props;
  const [mobileOS, setMobileOS] = useState<MobileOS>();

  useEffect(() => {
    setMobileOS(detectMobileOS());
  }, []);

  if (mobileOS === MobileOS.ANDROID) {
    return (
      <Link href={GOOGLE_PLAY_LINK}>
        <Image src={googlePlay} alt={'googlePlay'} width={153} height={50} />
      </Link>
    );
  }

  if (mobileOS === MobileOS.IOS) {
    return (
      <Link href={APP_STORE_LINK}>
        <Image src={appStore} alt={'appStore'} width={170} height={50} />
      </Link>
    );
  }

  return showDesktop ? (
    <>
      <Link href={APP_STORE_LINK}>
        <Image src={appStore} alt={'appStore'} width={170} height={50} />
      </Link>
      <InlineGap desktop={24} />
      <Link href={GOOGLE_PLAY_LINK}>
        <Image src={googlePlay} alt={'googlePlay'} width={153} height={50} />
      </Link>
    </>
  ) : null;
};

export default SoftwareButton;
